<template>
  <div class="big not-yet-entered-doctor">

    <div class="page_title">未入驻医生</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container"
           style="padding: 10px 20px 20px 20px;">

        <div class="between">
          <!-- 搜索 -->
          <div class="search-box">
            <!-- 医生姓名 -->
            <div class="item">
              <span>医生姓名</span>
              <div class="item-content">
                <el-input v-model="notYetEnteredForm.doctor_name"
                          size="small"
                          clearable
                          @keyup.enter.native="seachEnterFun"
                          placeholder="医生姓名"></el-input>
              </div>
            </div>

            <!-- 医院 -->
            <div class="item">
              <span>医院</span>
              <div class="item-content">
                <el-input v-model="notYetEnteredForm.hospital"
                          size="small"
                          clearable
                          @keyup.enter.native="seachEnterFun"
                          placeholder="医院"></el-input>
              </div>
              <el-button type="primary"
                         size="small"
                         style="margin-left:10px"
                         @click="getList">查询</el-button>
            </div>

          </div>
          <!-- 操作按钮 -->
          <div class="btn-box">
            <el-button type="primary"
                       size="small"
                       style="margin-left:10px"
                       @click="batchIsShow">勾选设置</el-button>
            <el-button type="primary"
                       size="small"
                       style="margin-left:10px"
                       :disabled=" module_id_array[0] ? !module_id_array.includes('1651') : false"
                       @click="addOrEditDoctorBtn(-1)">新增</el-button>
            <el-button type="primary"
                       size="small"
                       style="margin-left:10px"
                       :disabled=" module_id_array[0] ? !module_id_array.includes('1653') : false"
                       @click="importDoctorBtn">导入</el-button>
          </div>
        </div>

        <div style="border: solid 1px #c9cbd6;">
          <el-table v-loading="tableLoading"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%; min-width: 1000px"
                    :header-cell-style="{ background: '#F5F5F5' }"
                    @selection-change="handleSelectionChange">
            <el-table-column type="selection"
                             width="55">
            </el-table-column>
            <el-table-column v-for="item in tableHeader"
                             :key="item.prop"
                             :prop="item.prop"
                             :label="item.label"
                             :width="item.width"
                             :align="item.align"
                             :sortable="item.sortable"
                             :fixed="item.fixed">
              <template slot-scope="scope">
                <div v-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'recommend_times'">
                  <el-link type="primary"
                           @click="lookDetail(scope.row)">{{ scope.row[item.prop] }}</el-link>
                </div>

                <div v-else-if="item.prop == 'introduction'">
                  <el-tooltip class="item"
                              effect="dark"
                              :content="scope.row[item.prop]"
                              placement="top-start">
                    <div class="text-ellipsis"
                         style="width:180px">{{ scope.row[item.prop] }}</div>
                  </el-tooltip>
                </div>

                <div v-else-if="item.prop == 'remark'">
                  <el-tooltip class="item"
                              effect="dark"
                              :content="scope.row[item.prop]"
                              placement="top-start">
                    <div class="text-ellipsis"
                         style="width:100px">{{ scope.row[item.prop] }}</div>
                  </el-tooltip>
                </div>

                <div v-else-if="item.prop == 'is_show'">
                  <el-switch v-model="scope.row[item.prop]"
                             :active-value="1"
                             :inactive-value="0"
                             :disabled=" module_id_array[0] ? !module_id_array.includes('1650') : false"
                             @change="changeIsShowSwitch(scope.row)">
                  </el-switch>
                </div>

                <div v-else>{{ scope.row[item.prop] }}</div>
              </template>
            </el-table-column>

            <el-table-column label="操作"
                             width="120"
                             align="center"
                             fixed="right">
              <template slot-scope="scope">
                <el-button type="text"
                           size="medium"
                           :disabled=" module_id_array[0] ? !module_id_array.includes('1652') : false"
                           @click="addOrEditDoctorBtn(scope.row)">编辑</el-button>
                <el-button type="text"
                           size="medium"
                           :disabled=" module_id_array[0] ? !module_id_array.includes('1649') : false"
                           @click="delBtn(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination v-show="totalNum>0"
                    :total="totalNum"
                    :page.sync="pagination.page"
                    :limit.sync="pagination.pageNumber"
                    @pagination="getList" />
      </div>
    </div>
    <!-- 推荐入驻详情 -->
    <el-dialog title="推荐入驻详情"
               :visible.sync="detailDataVisible">
      <div style="padding:10px">
        <div class="search-box">

          <!-- 医生姓名 -->
          <div class="item">
            <span>医生姓名</span>
            <div class="item-content">
              <el-input v-model="detailForm.doctor_name"
                        size="small"
                        clearable
                        placeholder="医生姓名"></el-input>
            </div>
            <el-button type="primary"
                       size="small"
                       style="margin-left:10px"
                       @click="getDetailList">查询</el-button>
          </div>

        </div>
        <el-table :data="detailData"
                  tooltip-effect="dark"
                  style="width: 100%; "
                  :header-cell-style="{ background: '#F5F5F5' }">
          <el-table-column v-for="item in detailTableHeader"
                           :key="item.prop"
                           :prop="item.prop"
                           :label="item.label"
                           :width="item.width"
                           :align="item.align"
                           :sortable="item.sortable"
                           :fixed="item.fixed">
            <template slot-scope="scope">
              <div v-if="item.prop == 'create_time'">
                {{ scope.row[item.prop] | dateFormat }}
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagination v-show="detailDataTotalNum>0"
                    :total="detailDataTotalNum"
                    :page.sync="detailDataPagination.page"
                    :limit.sync="detailDataPagination.pageNumber"
                    @pagination="getDetailList" />
      </div>
    </el-dialog>
    <!-- 新增编辑医生 -->
    <el-dialog :title="`${isEdit ? '编辑' : '添加 '}`"
               :visible.sync="doctorVisible"
               width="700px"
               :close-on-click-modal="false"
               custom-class="cus-ListMaintain">
      <div style="text-align:left;padding:20px">
        <el-form :model="doctorForm"
                 :rules="rules"
                 ref="doctorVisibleRef"
                 label-width="100px"
                 class="ListMaintain-ruleForm">
          <div class="cases-box">
            <el-form-item label="医生姓名"
                          prop="doctor_name">
              <el-input v-model="doctorForm.doctor_name"
                        size="small"
                        clearable
                        maxlength="8"
                        placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="医生医院"
                          prop="hospital"
                          class="title">
              <el-input v-model="doctorForm.hospital"
                        size="small"
                        clearable
                        maxlength="50"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="医生头像"
                          prop="head_img"
                          class="main-img">
              <UploadImg :f_thumb="doctorForm.head_img"
                         :f_thumb_str="doctorForm.head_img_str"
                         @emitImg="emitMainImg"></UploadImg>
              <div class="prompt">建议尺寸662*358px</div>
            </el-form-item>

            <el-form-item label="所在省市"
                          prop="province_city_name"
                          class="title">
              <el-input v-model="doctorForm.province_city_name"
                        size="small"
                        clearable
                        maxlength="50"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="职称"
                          prop="title">
              <el-input v-model="doctorForm.title"
                        size="small"
                        clearable
                        maxlength="8"
                        placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="医生科室"
                          prop="department_name">
              <el-input v-model="doctorForm.department_name"
                        size="small"
                        clearable
                        maxlength="10"
                        placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="擅长方向"
                          prop="be_good_at_name"
                          class="title">
              <el-input v-model="doctorForm.be_good_at_name"
                        size="small"
                        clearable
                        maxlength="50"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="医生简介"
                          prop="introduction"
                          class="desc-form-item">
              <el-input v-model="doctorForm.introduction"
                        size="small"
                        clearable
                        maxlength="500"
                        type="textarea"
                        :rows="6"
                        placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="备注"
                          prop="remark"
                          class="desc-form-item">
              <el-input v-model="doctorForm.remark"
                        size="small"
                        clearable
                        maxlength="500"
                        type="textarea"
                        :rows="6"
                        placeholder="请输入"></el-input>
            </el-form-item>

          </div>

        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="doctorVisible=false"
                   size="medium"
                   plain>取 消</el-button>
        <el-button type="primary"
                   size="medium"
                   @click="doctorVisibleConfirm('doctorVisibleRef')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入 -->
    <import-excel :isFlag="isImport"
                  interfaceName="importDoctorHouse"
                  paramsKey="doctor_house_pic"
                  temName="doctor_house_pic"
                  @refreshList="getList"></import-excel>
  </div>

</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import doctor from '@/api/doctor.js';
import Pagination from '@/components/Pagination/index';
import UploadImg from '@/components/uploadImg/index';
import ImportExcel from '@/components/importExcel/index.vue';
export default {
  components: {
    Pagination,
    UploadImg,
    ImportExcel
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      notYetEnteredForm: {
        doctor_name: '',
        hospital: '',
        order_key: '',
        order_value: ''
      },
      tableData: [],
      tableHeader: [
        {
          label: '医生姓名',
          prop: 'doctor_name',
          width: '120',
          align: 'center',
          sortable: false,
          fixed: 'left'
        },
        {
          label: '医院',
          prop: 'hospital',
          width: '200',
          align: 'center',
          sortable: false,
          fixed: false
        },
        {
          label: '所在省市',
          prop: 'province_city_name',
          width: '200',
          align: 'center',
          sortable: false,
          fixed: false
        },
        {
          label: '职称',
          prop: 'title',
          width: '100',
          align: 'center',
          sortable: false,
          fixed: false
        },
        {
          label: '医生科室',
          prop: 'department_name',
          width: '200',
          align: 'center',
          sortable: false,
          fixed: false
        },
        {
          label: '擅长方向',
          prop: 'be_good_at_name',
          width: '200',
          align: 'center',
          sortable: false,
          fixed: false
        },
        {
          label: '医生简介',
          prop: 'introduction',
          width: '200',
          align: 'center',
          sortable: false,
          fixed: false
        },
        {
          label: '备注',
          prop: 'remark',
          width: '140',
          align: 'center',
          sortable: false,
          fixed: false
        },
        {
          label: '日期',
          prop: 'create_time',
          width: '160',
          align: 'center',
          sortable: false,
          fixed: false
        },
        {
          label: '推荐入驻次数',
          prop: 'recommend_times',
          width: '130',
          align: 'center',
          sortable: 'custom',
          fixed: 'right'
        },
        {
          label: '是否可搜索',
          prop: 'is_show',
          width: '100',
          align: 'center',
          sortable: false,
          fixed: 'right'
        }
      ],
      multipleSelection: [],
      detailDataVisible: false,
      detailDataTotalNum: 0,
      detailDataPagination: {
        page: 1,
        pageNumber: 10
      },
      detailForm: {
        doctor_name: ''
      },
      detailData: [],
      detailTableHeader: [
        {
          label: '医生姓名',
          prop: 'doctor_name',
          width: 'auto',
          align: 'center',
          sortable: false,
          fixed: false
        },
        {
          label: '用户ID',
          prop: 'user_id',
          width: 'auto',
          align: 'center',
          sortable: false,
          fixed: false
        },
        {
          label: '推荐用户昵称',
          prop: 'nick_name',
          width: 'auto',
          align: 'center',
          sortable: false,
          fixed: false
        },
        {
          label: '推荐用户手机号',
          prop: 'phone',
          width: 'auto',
          align: 'center',
          sortable: false,
          fixed: false
        },
        {
          label: '推荐时间',
          prop: 'create_time',
          width: 'auto',
          align: 'center',
          sortable: false,
          fixed: false
        }
      ],
      isEdit: false,
      doctorVisible: false,
      doctorForm: {
        doctor_name: '',
        hospital: '',
        title: '',
        department_name: '',
        head_img: '',
        be_good_at_name: '',
        province_city_name: '',
        introduction: '',
        remark: ''
      },
      rules: {
        doctor_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        hospital: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      isImport: false
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:mm');
    },
    settlementText(val) {
      switch (val) {
        case 0:
          return '未结算';
        case 1:
          return '已结算';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign({}, this.pagination, this.notYetEnteredForm);
      this.tableLoading = true;
      doctor.getDoctorHouseList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.tableData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    /***  是否可搜索---start  ***/
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchIsShow() {
      if (!this.multipleSelection.length) {
        this.$message.warning('请选择');
        return;
      }
      let d_ids = this.multipleSelection.map((item) => item.d_id).join(',');
      this.$confirm('请确定所勾选的医生是否可搜索设置为', '是否可搜索', {
        confirmButtonText: '开启',
        cancelButtonText: '关闭',
        distinguishCancelAndClose: true,
        type: 'warning',
        customClass: 'notYetEnteredDoctorConfirm'
      })
        .then(() => {
          this.changeIsShow({ d_id: d_ids, is_show: 1 });
        })
        .catch((str) => {
          if (str == 'cancel') {
            this.changeIsShow({ d_id: d_ids, is_show: 0 });
          }
        });
    },
    changeIsShowSwitch(row) {
      let { is_show } = row;
      let text = is_show == 1 ? '可搜索' : '不可搜索';
      this.$confirm(`确定当前医生${text}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.changeIsShow(row);
        })
        .catch(() => {
          row.is_show = !row.is_show ? 1 : 0;
        });
    },
    changeIsShow(row) {
      let { d_id, is_show } = row;
      doctor.setDoctorHouseShow({ d_id, is_show }).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success('设置成功');
          this.getList();
        }
      });
    },
    /***  是否可搜索---end  ***/
    /***  查看详情---start  ***/
    lookDetail(row) {
      let { doctor_name } = row;
      this.detailForm.doctor_name = doctor_name;
      this.getDetailList();
    },
    getDetailList() {
      let params = Object.assign(
        {},
        this.detailDataPagination,
        this.detailForm
      );
      doctor.getDoctorHouseRecommendList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.detailData = data.list;
          this.detailDataTotalNum = data.total;
          this.detailDataVisible = true;
        }
      });
    },
    /***  查看详情---end  ***/
    /***  删除---start  ***/
    delBtn(row) {
      let { d_id } = row;
      this.$confirm('确定要删除当前医生吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          doctor.deleteDoctorHouse({ d_id }).then((res) => {
            let { code } = res;
            if (code === 0) {
              this.$message.success('删除成功');
              this.getList();
            }
          });
        })
        .catch((str) => {});
    },
    /***  删除---end  ***/
    /***  添加编辑医生---start  ***/
    // 添加/编辑banner
    addOrEditDoctorBtn(row) {
      if (row != -1) {
        this.doctorForm.banner_id = row.banner_id;
        let data = _.pick(row, [
          'd_id',
          'doctor_name',
          'hospital',
          'title',
          'department_name',
          'head_img',
          'head_img_str',
          'be_good_at_name',
          'province_city_name',
          'introduction',
          'remark'
        ]);
        this.doctorForm = Object.assign({}, this.doctorForm, data);
        this.isEdit = true;
      } else {
        this.isEdit = false;
        for (let key in this.doctorForm) {
          this.doctorForm[key] = '';
        }
      }
      this.$refs['doctorVisibleRef']
        ? this.$refs['doctorVisibleRef'].clearValidate()
        : ' ';
      this.doctorVisible = true;
    },
    // 上传图片
    emitMainImg(data) {
      this.doctorForm.head_img = data.pic;
      this.doctorForm.head_img_str = data.path;
    },
    doctorVisibleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.doctorForm);
          let interfaceName = 'addDoctorHouse';
          if (this.isEdit) {
            interfaceName = 'updateDoctorHouse';
          } else {
            interfaceName = 'addDoctorHouse';
          }
          const loading = this.$loading();
          doctor[interfaceName](params)
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success(`${this.isEdit ? '编辑' : '添加'}成功`);
                this.getList();
              }
              this.doctorVisible = false;
              loading.close();
            })
            .catch((err) => {
              loading.close();
              this.doctorVisible = false;
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /***  添加编辑医生---start  ***/
    importDoctorBtn() {
      this.isImport = !this.isImport;
    }
  }
};
</script>

<style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.not-yet-entered-doctor {
  .search-box {
    display: flex;
    // justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      // width: 23%;
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        width: 60px;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
      }
    }
    .item-content {
      width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss"  >
.notYetEnteredDoctorConfirm {
  width: 380px !important;
  .el-message-box__status {
    left: 42px;
  }
}
</style>
<style lang="scss" scoped>
.cus-ListMaintain {
  .ListMaintain-ruleForm {
    .title {
      ::v-deep .el-form-item__content {
        height: 60px;
      }
    }
    .main-img {
      ::v-deep .el-form-item__content {
        height: 140px;
      }
    }
    .desc-form-item {
      ::v-deep .el-form-item__content {
        height: 140px;
      }
    }
  }
}
</style>